import { TabList as HeadlessUITabList } from "@headlessui/react";
import type { VariantProps } from "class-variance-authority";
import clsx from "clsx";
import type { ChildrenProps } from "../types";
import { tabListClasses } from "./shared";

/** Props Interface */
interface TabListProps extends ChildrenProps, VariantProps<typeof tabListClasses> {}

export function TabList({ children, variant }: TabListProps) {
	const classes = tabListClasses({ variant });

	/** Render */
	return (
		<div className={classes}>
			<HeadlessUITabList
				contextMenu="false"
				as="div"
				className={clsx(
					"tab-list",
					"text-color text-sm",
					"divide-x dark:divide-primaryGray-800 divide-primaryGray-100",
					"card hidden md:inline-flex",
					"max-w-[100vw]",
					"rounded-base",
					"p-0",
					"font-medium",
					"cursor-pointer",
					"shrink-0",
					"w-max",
					"overflow-hidden",
				)}
			>
				{children}
			</HeadlessUITabList>
		</div>
	);
}
